import RichUpdatesItemShare from './RichUpdatesItemShare';

export default RichUpdatesItemShare;
